import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';

import { ActionButton, CustomDialogTitle } from 'components';
import { DialogContent, DialogActions, Dialog } from '@mui/material';
import * as icons from 'mdi-material-ui';
import { useSmallScreen } from 'utils/hooks/ui';

const SubscriptionStartDialog = ({ open, handleConfirm, loading }) => {
    const fullScreen = useSmallScreen();

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            sx={theme => ({ [theme.breakpoints.down('sm')]: { minWidth: 'unset' } })}
        >
            <CustomDialogTitle hideClose title={texts.START_SUBSCRIPTION} />
            <DialogContent
                sx={theme => ({ padding: theme.spacing(2, 3), color: theme.palette.grey[600] })}
            >
                {texts.START_YOUR_CLIENT_SUBSCRIPTION}
            </DialogContent>
            <DialogActions>
                <ActionButton
                    loading={loading}
                    onClick={() => handleConfirm()}
                    sx={theme => ({
                        letterSpacing: '1.3px',
                        '&:hover': { background: 'inherit' },
                        [theme.breakpoints.down('sm')]: { width: '100%' },
                    })}
                >
                    {texts.CONTINUER} <icons.ArrowRight />
                </ActionButton>
            </DialogActions>
        </Dialog>
    );
};

SubscriptionStartDialog.propTypes = {
    open: PropTypes.bool,
    loading: PropTypes.bool,
    handleConfirm: PropTypes.func,
};

export default SubscriptionStartDialog;
